import React from "react";
import {
  ELEMENT_TYPE_UBD_ATL,
  ELEMENT_TYPE_UBD_LEARNING_STANDARD,
  ELEMENT_TYPE_UBD_SUBJECT,
  ELEMENT_TYPE_UBD_COURSE,
  ELEMENT_TYPE_UNIT_PLAN,
  ELEMENT_TYPE_MYP_ATL,
  ELEMENT_TYPE_DP_ATL,
  ELEMENT_TYPE_DP_LEARNER_PROFILE,
  ELEMENT_TYPE_DP_OBJECTIVES,
  IB_PYP_ELEMENT_TYPE_DP,
  ELEMENT_TYPE_MYP_OBJECTIVES,
  ELEMENT_TYPE_MYP_SUBJECT,
  ELEMENT_TYPE_MYP_PROJECT,
  ELEMENT_TYPE_PYP_SUBJECT,
  ELEMENT_TYPE_MYP_LEARNING_STANDARD,
  ELEMENT_TYPE_DP_SUBJECT_STANDARD,
  ELEMENT_TYPE_DP_SUBJECT,
  ELEMENT_TYPE_DP_CAS,
  ELEMENT_TYPE_CP_SL,
  ELEMENT_TYPE_CP_CE,
  ELEMENT_TYPE_CP_RP,
  ADVISOR,
  ELEMENT_TYPE_DP_EXTENDED_ESSAY,
  ELEMENT_TYPE_DP_TOK,
  ELEMENT_TYPE_MYP_PERSONAL_PROJECT,
  ELEMENT_TYPE_MYP_COMMUNITY_PROJECT,
  ELEMENT_TYPE_DP_CAS_LEARNING_OUTCOMES,
  ELEMENT_TYPE_CP_SL_LEARNING_OUTCOMES,
  ELEMENT_TYPE_CE_LEARNING_OUTCOMES,
  ELEMENT_TYPE_MYP_SERVICE_ACTION_OUTCOME,
  SUPERVISORS,
  ELEMENT_TYPE_MYP_LEARNER_PROFILE,
  ELEMENT_TYPE_PYP_LEARNING_STANDARD,
  ELEMENT_TYPE_PYP_ATL,
  SUBJECT,
  COURSE,
  CURRICULUM_TYPE_PYP,
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_UBD,
  CURRICULUM_TYPE_DP,
  NODE_TYPE_IB_PYP_CURRICULUM_PROGRAM,
  NODE_TYPE_IB_MYP_CURRICULUM_PROGRAM,
  NODE_TYPE_UBD_CURRICULUM_PROGRAM,
  NODE_TYPE_IB_DP_CURRICULUM_PROGRAM,
} from "Constants/stringConstants";
import {
  SUBJECT_LEVEL,
  COURSE_LEVEL,
  PROGRESS_SUMMARY_SUBJECTS,
  PROGRESS_SUMMARY_COURSES,
} from "ProgressReportCommon/modules/stringConstants";
import {
  PrintOutlined,
  LockOpenOutlined,
  LockFilled,
  UserArrowOutlined,
  UserCloseOutlined,
  TeacherAddOutlined,
  DownloadOutlined,
  UserArrowInwardOutlined,
  TagOutlined,
  CommentMultipleColored,
  SheetsColored,
} from "@toddle-edu/ds-icons";
import { Trans } from "react-i18next";

export const pypElementMapping = {
  pypSubject: ELEMENT_TYPE_PYP_SUBJECT,
  pypLearningStandard: ELEMENT_TYPE_PYP_LEARNING_STANDARD,
  pypAtl: ELEMENT_TYPE_PYP_ATL,
  lp: "LEARNER_PROFILE",
  concept: "CONCEPT",
  atl: "ATL",
  benchmark: "BENCHMARK",
  mypObjectives: ELEMENT_TYPE_MYP_OBJECTIVES,
  mypAtl: ELEMENT_TYPE_MYP_ATL,
  mypSubject: ELEMENT_TYPE_MYP_SUBJECT,
  mypProject: ELEMENT_TYPE_MYP_PROJECT,
  ubdAtl: ELEMENT_TYPE_UBD_ATL,
  ubdLearningStandard: ELEMENT_TYPE_UBD_LEARNING_STANDARD,
  ubdSubject: ELEMENT_TYPE_UBD_SUBJECT,
  ubdCourse: ELEMENT_TYPE_UBD_COURSE,
  unitPlan: ELEMENT_TYPE_UNIT_PLAN,
  mypLearningStandard: ELEMENT_TYPE_MYP_LEARNING_STANDARD,
  mypLearnerProfile: ELEMENT_TYPE_MYP_LEARNER_PROFILE,
  dpSubjectStandard: ELEMENT_TYPE_DP_SUBJECT_STANDARD,
  dpAtl: ELEMENT_TYPE_DP_ATL,
  dpLearnerProfile: ELEMENT_TYPE_DP_LEARNER_PROFILE,
  dpObjectives: ELEMENT_TYPE_DP_OBJECTIVES,
  dpCriteria: IB_PYP_ELEMENT_TYPE_DP,
  dpCas: ELEMENT_TYPE_DP_CAS,
  cpSl: ELEMENT_TYPE_CP_SL,
  cpCe: ELEMENT_TYPE_CP_CE,
  cpRp: ELEMENT_TYPE_CP_RP,
  dpEe: ELEMENT_TYPE_DP_EXTENDED_ESSAY,
  dpTok: ELEMENT_TYPE_DP_TOK,
  mypPp: ELEMENT_TYPE_MYP_PERSONAL_PROJECT,
  mypCp: ELEMENT_TYPE_MYP_COMMUNITY_PROJECT,
  dpCasLearningOutcomes: ELEMENT_TYPE_DP_CAS_LEARNING_OUTCOMES,
  cpSlLearningOutcomes: ELEMENT_TYPE_CP_SL_LEARNING_OUTCOMES,
  cpCELearningOutcomes: ELEMENT_TYPE_CE_LEARNING_OUTCOMES,
  dpCasLearningOutcome: ELEMENT_TYPE_DP_CAS_LEARNING_OUTCOMES,
  dpSubject: ELEMENT_TYPE_DP_SUBJECT,
  serviceLearningOutcome: ELEMENT_TYPE_MYP_SERVICE_ACTION_OUTCOME,
};

export const updatedPypElementMapping = {
  benchmark: "PYP_LEARNING_STANDARD",
  atl: "PYP_ATL",
  lp: "PYP_LEARNER_PROFILE",
  concept: "PYP_KEY_CONCEPT",
};

export const NEW_REPORTS_IB_DEFINED_GRADE_SCALE_TYPES = [
  "MYP_IB_DEFINED",
  "MYP_CRITERIA_TOTAL",
  "MYP_FINAL_GRADE",
  "DP_IB_DEFINED",
];

export const plannerElementCustomColumnConfig = {
  [ELEMENT_TYPE_DP_CAS_LEARNING_OUTCOMES]: [
    {
      label: "common:achievement_status",
      dataKey: "isAchieved",
      columnType: "TICK",
    },
  ],
  [ELEMENT_TYPE_CP_SL_LEARNING_OUTCOMES]: [
    {
      label: "common:achievement_status",
      dataKey: "isAchieved",
      columnType: "TICK",
    },
  ],
  [ELEMENT_TYPE_CE_LEARNING_OUTCOMES]: [
    {
      label: "common:status",
      dataKey: "isAchieved",
      columnType: "TICK",
    },
  ],
  [ELEMENT_TYPE_MYP_SERVICE_ACTION_OUTCOME]: [
    {
      label: "studentProgressSummary:num_of_times_addressed",
      dataKey: "noOfActivities",
      columnType: "NUMBER",
    },
    {
      label: "studentProgressSummary:num_of_evidences",
      dataKey: "noOfEvidences",
      columnType: "NUMBER",
    },
  ],
};
//this mapping takes the uid and gives whether it is advisor or supervisor

export const uidToProjectHeadMapping = {
  [ELEMENT_TYPE_DP_CAS]: ADVISOR,
  [ELEMENT_TYPE_DP_EXTENDED_ESSAY]: SUPERVISORS,
  [ELEMENT_TYPE_DP_TOK]: SUPERVISORS,
};

export const DYNAMIC_CRITERIA_TYPES_FOR_PP_PROJECTS = [
  "PROJECT_OVERALL_PROGRESS",
  "PROJECT_FINAL_GRADE",
];

export const DYNAMIC_CRITERIA_TYPES_FOR_CP_PROJECTS = [
  "PROJECT_OVERALL_PROGRESS",
];

export const DYNAMIC_CRITERIA_TYPES_FOR_SA_PROJECTS = [
  "PROJECT_OVERALL_PROGRESS",
];

export const DYNAMIC_CRITERIA_TYPES_FOR_CAS_SL_PROJECTS = [
  "PROJECT_OVERALL_PROGRESS",
];

export const DYNAMIC_CRITERIA_TYPES_FOR_EE_RP_PROJECTS = [
  "PROJECT_OVERALL_PROGRESS",
  "CRITERIA_RUBRIC_FINAL_GRADE",
];

export const CUSTOM_CRITERIA_TYPES_FOR_EE_RP_PROJECTS = [
  "PROJECT_CRITERIA_GRADE",
];

export const DYNAMIC_CRITERIA_TYPES_FOR_TOK_PROJECTS = [
  "PROJECT_OVERALL_PROGRESS",
  "PROJECT_FINAL_SCORE",
  "PROJECT_FINAL_GRADE",
];

export const DYNAMIC_CRITERIA_TYPES = [
  "ASSESSMENT_CATEGORY",
  "FINAL_SCORE",
  "FINAL_GRADE",
  "LOCAL_GRADE",
  "PRIMARY_FINAL_GRADE",
];

export const DYNAMIC_CRITERIA_TYPES_FOR_TOK_OVERALL_PROJECTS = [
  "PROJECT_FINAL_SCORE",
  "PROJECT_FINAL_GRADE",
];

export const GPA_ASSOCIATED_DYNAMIC_CRITERIA_TYPES = [
  "GRADE_POINT",
  "QUALITY_POINT",
  "CREDIT",
  "GRADE_POINT_AVERAGE",
];

export const GPA_ASSOCIATED_CRITERIA_TYPES_EXCLUDED_FROM_SUBJECT_LEVEL_CRITERIA_SET = [
  "GRADE_POINT_AVERAGE",
  "GP_GRADE_BOUNDARY",
];

export const GPA_ASSOCIATED_CRITERIA_TYPES = [
  "GRADE_POINT",
  "CREDIT",
  "QUALITY_POINT",
  "GRADE_POINT_AVERAGE",
];

export const GPA_ASSOCIATED_CRITERIA_TYPES_ELIGIBLE_FOR_AGGREGATION = [
  "CREDIT",
  "QUALITY_POINT",
];

export const CURRICULUM_NODE_ENTITY_TYPE_MAPPING = {
  [CURRICULUM_TYPE_PYP]: NODE_TYPE_IB_PYP_CURRICULUM_PROGRAM,
  [CURRICULUM_TYPE_MYP]: NODE_TYPE_IB_MYP_CURRICULUM_PROGRAM,
  [CURRICULUM_TYPE_UBD]: NODE_TYPE_UBD_CURRICULUM_PROGRAM,
  [CURRICULUM_TYPE_DP]: NODE_TYPE_IB_DP_CURRICULUM_PROGRAM,
};

export const objectiveNodeUids = [
  "INTERDISCIPLINARY_OBJECTIVES",
  "SUBJECT_OBJECTIVES",
  "PP_CRITERIA",
  "CP_CRITERIA",
  "EE_ASSESSMENT_CRITERIA",
  "RP_ASSESSMENT_CRITERIA",
];

export const LEARNING_OUTCOME_CRITERIA_TYPE = "LEARNING_OUTCOME_LEVEL";

export const criteriaTypesForCumulativeReport = [
  "MYP_CRITERIA_FINAL_SCORE",
  "FINAL_SCORE",
  "FINAL_GRADE",
  "LOCAL_GRADE",
  "GRADE_POINT",
  "CREDIT",
  "QUALITY_POINT",
];

export const NOT_SHOW_FOOTER_SECTIONS = ["sheet"];

export const DYNAMIC_PYPELEMENTS = [
  "atl",
  "benchmark",
  "mypAtl",
  "dpAtl",
  "ubdAtl",
  "ubdLearningStandard",
  "mypLearningStandard",
  "dpSubjectStandard",
];

// PYP elements to show with levels in report

export const MYP_CRITERIA_FINAL_SCORE = "MYP_CRITERIA_FINAL_SCORE";

export const IB_DEFINED_CRITERIA_TYPES = [
  "IB_DEFINED",
  "MYP_CRITERIA_FINAL_SCORE",
];

// PYP elements to show without levels in report

export const EE_FINAL_GRADE_SUBTYPES = ["EE", "EE_2027"];

export const RP_FINAL_GRADE_SUBTYPES = ["RP", "RP_2027"];

// Initial state of steps data

export const LEVEL_NODE_UIDS = [SUBJECT_LEVEL, COURSE_LEVEL];

export const SUBJECT_OR_COURSE_UIDS = [SUBJECT, COURSE];

export const PROGRESS_SUMMARY_SUBJECT_OR_COURSE_UIDS = [
  PROGRESS_SUMMARY_SUBJECTS,
  PROGRESS_SUMMARY_COURSES,
];

export const achievementCriterionLabels = [
  { label: "A", objectiveLabel: "A:" },
  { label: "B", objectiveLabel: "B:" },
  { label: "C", objectiveLabel: "C:" },
  { label: "D", objectiveLabel: "D:" },
];

export const AVATAR_BACKGROUND_COLORS = [
  "violet",
  "blue",
  "yellow",
  "pink",
  "teal",
];

export const COMMON_ACTIONS_FOR_REPORT = ({
  getShareReportTo,
  showTagSnPCondition = () => {},
  isGradeLevelAction = false,
  singleReportAction = false,
}) => {
  return [
    {
      id: "RATINGS_LOGS_MODAL",
      icon: SheetsColored,
      group: 0,
      validStates: ["PENDING", "DONE", "LOCKED", "PUBLISHED"],
      label: () => "Ratings logs",
      perm: "FeatureFlag:AddProgressReportInternalTools",
    },
    {
      id: "REMARKS_LOGS_MODAL",
      icon: CommentMultipleColored,
      group: 0,
      validStates: ["PENDING", "DONE", "LOCKED", "PUBLISHED"],
      label: () => "Remarks logs",
      perm: "FeatureFlag:AddProgressReportInternalTools",
    },
    {
      id: "LOCK",
      icon: LockFilled,
      group: 0,
      status: "LOCKED",
      validStates: ["PENDING", "DONE"],
      validStatesMultiple: ["PENDING", "DONE"],
      direction: "FORWARD",
      title: ({ t }) => {
        return t("common:lock_with_label", {
          label: t("common:lowercase", {
            text: t("progressReport:progress_report_other"),
          }),
        });
      },
      message: ({
        count,
        studentName = "",
        selectedCourseCount = 0,
        selectedActionReportsCount = 0,
        selectedCourseName = "",
        isNonPYPCurriculum = false,
      }) => {
        if (isGradeLevelAction) {
          const multiCourseKey = isNonPYPCurriculum
            ? "progressReport:non_pyp_grade_lock_report_confirmation_text"
            : "progressReport:grade_lock_report_confirmation_text";
          const lockI18nKey =
            selectedCourseCount > 1
              ? multiCourseKey
              : "progressReport:single_grade_lock_report_confirmation_text";
          return (
            <Trans
              i18nKey={lockI18nKey}
              count={selectedActionReportsCount}
              values={{
                count: selectedActionReportsCount,
                name: selectedCourseName,
              }}
              components={{
                b: <b className="text-label" />,
              }}
            />
          );
        }
        return (
          <Trans
            i18nKey="progressReport:lock_report_confirmation_text"
            count={count}
            values={{ count, studentName }}
            components={{
              b: <b className="text-label" />,
            }}
          >
            Are you sure you want to <bold>lock progress report</bold> for{" "}
            <bold>{{ studentName }}</bold>?
          </Trans>
        );
      },
      label: ({ t }) => {
        return t("common:lock_with_label", {
          label: t("common:lowercase", {
            text: singleReportAction
              ? t("progressReport:progress_report")
              : t("progressReport:progress_report_other"),
          }),
        });
      },
      tooltip: ({ t }) => {
        return t("common:lock_with_label", {
          label: t("common:lowercase", {
            text: singleReportAction
              ? t("progressReport:progress_report")
              : t("progressReport:progress_report_other"),
          }),
        });
      },
      toastMsg: ({ t, count }) => {
        if (isGradeLevelAction) {
          return t("progressReport:grade_locked_successfully_with_count", {
            count,
          });
        }
        return t("progressReport:locked_successfully_with_count", { count });
      },
      toastLabel: () => {},
      showConfirmationBox: true,
      button2Text: ({ t, count }) => {
        return t("common:yes_with_action", {
          action: t("common:lock_with_label", {
            label: t("common:lowercase", {
              text: t("progressReport:progress_report", { count }),
            }),
          }),
        });
      },
      alertText: ({ t, count, isNonPYPCurriculum = false }) => {
        if (isGradeLevelAction) {
          return t("progressReport:grade_lock_report_alert_text");
        }
        if (isNonPYPCurriculum) {
          return count > 1
            ? t("progressReport:non_pyp_lock_report_alert_text")
            : t("progressReport:non_pyp_single_lock_report_alert_text");
        }
        return t("progressReport:lock_report_alert_text", { count });
      },
      alertType: "info",
      primaryButtonText: ({ t }) => {
        return t("progressReport:lock_progress_reports_confirm_button_text");
      },
      showWarningText: false,
      warningText: () => {},
      showAlertCheckbox: false,
    },
    {
      id: "UNLOCK",
      icon: LockOpenOutlined,
      group: 0,
      status: "PENDING",
      validStates: ["LOCKED", "LOCKING"],
      validStatesMultiple: ["LOCKED", "LOCKING"],
      direction: "BACKWARD",
      label: ({ t }) => {
        return t("common:unlock_with_label", {
          label: t("common:lowercase", {
            text: singleReportAction
              ? t("progressReport:progress_report")
              : t("progressReport:progress_report_other"),
          }),
        });
      },
      title: ({ t }) => {
        return t("common:unlock_with_label", {
          label: t("common:lowercase", {
            text: t("progressReport:progress_report_other"),
          }),
        });
      },
      message: ({
        count,
        studentName = "",
        selectedCourseCount,
        selectedActionReportsCount,
        selectedCourseName = "",
        isNonPYPCurriculum = false,
      }) => {
        if (isGradeLevelAction) {
          const multiCourseUnlockKey = isNonPYPCurriculum
            ? "progressReport:non_pyp_grade_unlock_report_confirmation_text"
            : "progressReport:grade_unlock_report_confirmation_text";
          const unlockI18nKey =
            selectedCourseCount > 1
              ? multiCourseUnlockKey
              : "progressReport:single_grade_unlock_report_confirmation_text";
          return (
            <Trans
              i18nKey={unlockI18nKey}
              count={selectedActionReportsCount}
              values={{
                count: selectedActionReportsCount,
                name: selectedCourseName,
              }}
              components={{
                b: <b className="text-label" />,
              }}
            />
          );
        }
        return (
          <Trans
            i18nKey="progressReport:unlock_report_confirmation_text"
            count={count}
            values={{ count, studentName }}
            components={{
              b: <b className="text-label" />,
            }}
          >
            Are you sure you want to <b>unlock progress report</b> for{" "}
            <b>{{ studentName }}</b>?
          </Trans>
        );
      },
      tooltip: ({ t }) => {
        return t("common:unlock_with_label", {
          label: t("common:lowercase", {
            text: singleReportAction
              ? t("progressReport:progress_report")
              : t("progressReport:progress_report_other"),
          }),
        });
      },
      toastMsg: ({ t, count }) => {
        if (isGradeLevelAction) {
          return t("progressReport:grade_unlocked_successfully", { count });
        }
        return t("progressReport:unlocked_successfully_with_count", {
          count,
        });
      },
      showConfirmationBox: true,
      button1Text: ({ t }) => t("common:discard"),
      button2Text: ({ t, count }) => {
        return t("common:yes_with_action", {
          action: t("common:unlock_with_label", {
            label: t("common:lowercase", {
              text: t("progressReport:progress_report", { count }),
            }),
          }),
        });
      },
      button2Props: {
        variant: "progressive",
      },
      showWarningText: true,
      warningType: "warning",
      warningText: ({ t, count }) => {
        if (isGradeLevelAction) {
          return t("progressReport:grade_unlock_progress_report_warning", {
            count,
          });
        }
        return t("progressReport:unlock_progress_report_warning", { count });
      },
      alertText: ({ t, count }) => {
        if (isGradeLevelAction) {
          return t("progressReport:grade_unlock_report_alert_text");
        }
        return t("progressReport:unlock_report_alert_text", { count });
      },
      primaryButtonText: ({ t }) =>
        t("progressReport:unlock_progress_reports_confirm_button_text"),
      toastLabel: () => {},
      hasDivider: true,
    },
    {
      id: "PRINT",
      icon: PrintOutlined,
      group: 3,
      hideActionButton: true,
      validStates: ["PENDING", "DONE", "LOCKED", "PUBLISHED"],
      label: ({ t }) =>
        t("common:print_with_label", {
          label: t("common:preview"),
        }),
      tooltip: () => {},
      disabledTooltip: () => {
        return null;
      },
    },
    {
      id: "SHARE_WITH_PARENT",
      icon: UserArrowOutlined,
      group: 1,
      status: "PUBLISHED",
      validStates: ["LOCKED"],
      validStatesMultiple: ["LOCKED"],
      direction: "FORWARD",
      title: ({ t }) => {
        return t("common:share_with_label", {
          label: t("common:lowercase", {
            text: t("progressReport:progress_report_other"),
          }),
        });
      },
      message: ({
        count,
        studentName = "",
        selectedCourseCount,
        selectedActionReportsCount,
        selectedCourseName = "",
        isNonPYPCurriculum = false,
      }) => {
        if (isGradeLevelAction) {
          const multiCourseShareKey = isNonPYPCurriculum
            ? "progressReport:non_pyp_grade_share_report_confirmation_text"
            : "progressReport:grade_share_report_confirmation_text";
          const shareI18nKey =
            selectedCourseCount > 1
              ? multiCourseShareKey
              : "progressReport:single_grade_share_report_confirmation_text";
          return (
            <Trans
              i18nKey={shareI18nKey}
              count={selectedActionReportsCount}
              values={{
                count: selectedActionReportsCount,
                name: selectedCourseName,
              }}
              components={{
                b: <b className="text-label" />,
              }}
            />
          );
        }
        return (
          <Trans
            i18nKey="progressReport:share_confirmation_text"
            count={count}
            values={{ count, studentName }}
            components={{
              b: <b className="text-label" />,
            }}
          >
            Are you sure you want to <b>share the progress report</b> for{" "}
            <b>{{ studentName }}</b>?
          </Trans>
        );
      },
      alertCheckBoxMessage: ({
        t,
        canShareWithStudent,
        canShareWithFamily,
      }) => {
        const shareReportTo = getShareReportTo({
          canShareWithStudent,
          canShareWithFamily,
        });

        switch (shareReportTo) {
          case "family":
            return t(
              "progressReport:share_student_report_notify_checkbox_parents_only"
            );
          case "student":
            return t(
              "progressReport:share_student_report_notify_checkbox_students_only"
            );
          default:
            return t("progressReport:share_student_report_notify_checkbox");
        }
      },
      label: ({ t, canShareWithStudent, canShareWithFamily }) => {
        const shareReportTo = getShareReportTo({
          canShareWithStudent,
          canShareWithFamily,
        });

        let label = "";

        switch (shareReportTo) {
          case "family":
            label = t("common:family");
            break;
          case "student":
            label = t("common:student_plural");
            break;
          default:
            label = t("common:family_&_students");
        }

        return t("common:share_with_with_label", {
          label,
        });
      },
      tooltip: ({ t, canShareWithStudent, canShareWithFamily }) => {
        let label = "";

        const shareReportTo = getShareReportTo({
          canShareWithStudent,
          canShareWithFamily,
        });

        switch (shareReportTo) {
          case "family":
            label = t("common:family");
            break;
          case "student":
            label = t("common:student_plural");
            break;
          default:
            label = t("common:family_&_students");
        }

        return t("common:share_with_with_label", {
          label,
        });
      },
      toastMsg: ({ t, count }) => {
        if (isGradeLevelAction) {
          return t("progressReport:grade_shared_successfully", { count });
        }
        return t("progressReport:shared_successfully_with_count", { count });
      },
      showConfirmationBox: true,
      button2Text: ({ t, count }) => {
        return t("common:share_with_label", {
          label: t("common:lowercase", {
            text: t("progressReport:progress_report", { count }),
          }),
        });
      },
      button2Props: {
        variant: "progressive",
      },
      showAlertCheckbox: true,
      alertText: ({ t, count, canShareWithStudent, canShareWithFamily }) => {
        const shareReportTo = getShareReportTo({
          canShareWithStudent,
          canShareWithFamily,
        });
        switch (shareReportTo) {
          case "family":
            return t(
              "progressReport:share_report_alert_text_family_member_only"
            );
          case "student":
            return t("progressReport:share_report_alert_text_student_only", {
              count,
            });
          default:
            return t("progressReport:share_report_alert_text", { count });
        }
      },
      alertType: "info",
      primaryButtonText: ({ t }) => {
        return t("progressReport:share_progress_report_confirm_button_text");
      },
      warningText: () => {},
      toastLabel: () => {},
    },
    {
      id: "UNSHARE_WITH_PARENT",
      icon: UserArrowInwardOutlined,
      group: 1,
      status: "LOCKED",
      validStates: ["PUBLISHED"],
      direction: "BACKWARD",
      message: ({
        count,
        studentName = "",
        selectedCourseCount,
        selectedActionReportsCount,
        selectedCourseName = "",
        isNonPYPCurriculum = false,
      }) => {
        if (isGradeLevelAction) {
          const multiCourseWithdrawKey = isNonPYPCurriculum
            ? "progressReport:non_pyp_grade_withdraw_confirmation_text"
            : "progressReport:grade_withdraw_confirmation_text";
          const withdrawI18nKey =
            selectedCourseCount > 1
              ? multiCourseWithdrawKey
              : "progressReport:single_grade_withdraw_confirmation_text";
          return (
            <Trans
              i18nKey={withdrawI18nKey}
              count={selectedActionReportsCount}
              values={{
                count: selectedActionReportsCount,
                name: selectedCourseName,
              }}
              components={{
                b: <b className="text-label" />,
              }}
            />
          );
        }
        return (
          <Trans
            i18nKey="progressReport:withdraw_confirmation_text"
            count={count}
            values={{ count, studentName }}
            components={{
              b: <b className="text-label" />,
            }}
          >
            Are you sure you want to <b>withdraw the shared progress report</b>{" "}
            for <b>{{ studentName }}</b>?
          </Trans>
        );
      },
      label: ({ t }) => {
        return singleReportAction
          ? t("progressReport:withdraw_shared_report")
          : t("progressReport:withdraw_shared_reports");
      },
      tooltip: ({ t }) => {
        return singleReportAction
          ? t("progressReport:withdraw_shared_report")
          : t("progressReport:withdraw_shared_reports");
      },
      toastMsg: ({ t, count }) => {
        if (isGradeLevelAction) {
          return t("progressReport:grade_withdrawn_successfully", { count });
        }
        return t("progressReport:withdrawn_successfully_with_count", {
          count,
        });
      },
      showConfirmationBox: true,
      button2Text: ({ t, count }) => {
        return t("common:unshare_label", {
          label: t("common:lowercase", {
            text: t("progressReport:progress_report", { count }),
          }),
        });
      },
      title: ({ t }) => {
        return t("common:withdraw_shared_report_with_label", {
          label: t("common:lowercase", {
            text: t("progressReport:progress_report_other"),
          }),
        });
      },
      button2Props: {
        variant: "progressive",
      },
      showAlertCheckbox: false,
      alertText: ({ t, count }) => {
        return count > 1
          ? t("progressReport:grade_withdraw_report_alert_text")
          : t("progressReport:single_grade_withdraw_report_alert_text");
      },
      primaryButtonText: ({ t }) =>
        t("progressReport:withdraw_progress_reports_confirm_button_text"),
      warningText: () => {},
      toastLabel: () => {},
      hasDivider: true,
    },
    {
      id: "ENABLE_EVALUTAION",
      icon: TeacherAddOutlined,
      group: 2,
      status: "PENDING",
      validStates: ["NA"],
      label: ({ t }) => {
        return singleReportAction
          ? t("progressReport:include_student_in_the_report_set")
          : t("progressReport:include_students_in_the_report_set");
      },
      tooltip: ({ t }) =>
        t("progressReport:include_students_in_the_report_set"),
      toastMsg: ({ count }) => {
        let locale = "toastMsgs:progress_report_successfully_included_student";
        if (count > 1) {
          locale =
            "toastMsgs:progress_report_successfully_included_bulk_student";
        }
        return locale;
      },
      alertText: () => {},
      primaryButtonText: () => {},
      warningText: () => {},
    },
    {
      id: "DISABLE_EVALUATION",
      icon: UserCloseOutlined,
      group: 2,
      status: "NA",
      validStates: ["PENDING"],
      label: ({ t }) => {
        return singleReportAction
          ? t("progressReport:exclude_student_from_the_report_set")
          : t("progressReport:exclude_students_from_the_report_set");
      },
      tooltip: ({ t }) =>
        t("progressReport:exclude_students_from_the_report_set"),
      toastMsg: ({ count }) => {
        let locale = "toastMsgs:progress_report_successfully_excluded_student";
        if (count > 1) {
          locale =
            "toastMsgs:progress_report_successfully_excluded_bulk_student";
        }
        return locale;
      },
      alertText: () => {},
      primaryButtonText: () => {},
      warningText: () => {},
      toastLabel: () => {},
      hasDivider: true,
    },
    {
      id: "DOWNLOAD",
      icon: DownloadOutlined,
      group: isGradeLevelAction ? 2 : 3,
      validStates: ["LOCKED", "PUBLISHED"],
      showModal: true,
      label: ({ t }) => {
        return t("common:download_with_label", {
          label: t("common:lowercase", {
            text: singleReportAction
              ? t("progressReport:progress_report")
              : t("progressReport:progress_report_other"),
          }),
        });
      },
      tooltip: ({ t }) => {
        return t("common:download_with_label", {
          label: t("common:lowercase", {
            text: t("progressReport:progress_report_other"),
          }),
        });
      },
      title: () => {},
      message: () => {},
      alertText: () => {},
      primaryButtonText: () => {},
      warningText: () => {},
      toastMsg: () => {},
    },
    ...(showTagSnPCondition()
      ? [
          {
            id: "TAG_SNP",
            label: ({ t }) => t("common:tag_snp"),
            icon: TagOutlined,
            group: 3,
            validStates: ["PUBLISHED"],
            hideOnDisabled: true,
          },
        ]
      : []),
  ];
};

export const pypTypesToShowPlaceholders = [
  "mypLearnerProfile",
  "dpLearnerProfile",
  "dpObjectives",
];

export const TEMPLATE_VERSION_3_0 = "3.0";

export const projectCriteriaTypes = [
  "IB_DEFINED",
  "LEARNING_OUTCOME_LEVEL",
  "PROJECT_CRITERIA_GRADE",
];
export const IB_DEFINED = "IB_DEFINED";

export const childUidToCalculateModeFor = [
  "DP_TOK_ESSAY",
  "DP_TOK_EXHIBITION",
  "DP_TOK_OVERALL",
];
